import { CountableTimeZonePipe } from 'countable@helpers';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CacheFlowService } from '../../../../../services/cache-flow.service';

@Component({
  selector: 'app-cash-flow-work-statement',
  templateUrl: './cash-flow-work-statement.component.html',
  styleUrls: ['./cash-flow-work-statement.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CashFlowWorkStatementComponent implements OnInit {
  //properties
  testDate = "12-31-2019";
  engagementId              : number;
  selectedEngagementObj     : any;
  yearEnd                   : number;
  acctYear                  : number;
  userDetails               : any;
  userLoginId               : number;
  cashFlowData              : any;
  pageHeading               : string = "cash flow statement";
  currentYear               : string;
  previousYear              : string;

  constructor(public dialog: MatDialog,private cacheFlowService: CacheFlowService,private countableTimeZonePipe:CountableTimeZonePipe) { }

  ngOnInit() {
    this.selectedEngagementObj = JSON.parse((localStorage.getItem('selectedEngagementObj')));
    let year = this.countableTimeZonePipe.transform(this.selectedEngagementObj.yearEnd, 'yyyy');
    this.yearEnd = +year;
    this.engagementId = this.selectedEngagementObj.engagementsid;
    this.acctYear = +year;
    //get the user details
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.userLoginId = this.userDetails.useracctid;
    this.getCashFlowStatement();
  }
  getCashFlowStatement() {
    this.cacheFlowService.getCFReport(this.engagementId, this.yearEnd).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          const data = JSON.parse(res?.data);
          if (data && data.length > 0) {
            this.cashFlowData = data;
            this.currentYear = this.cashFlowData[0].years.curyear;
            this.previousYear = this.cashFlowData[0].years.prevyear;

          } else {
            this.cashFlowData = [];
          }
        }
      }
    })
  }

  refresh() {
    this.getCashFlowStatement();
  }
}
